import { makeStyles } from '@mui/styles';
import Modal from 'apollo-react/components/Modal';
import TextField from 'apollo-react/components/TextField';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { getSavedSearchExists } from '../../../api/saved-search';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { saveSavedSearchDesigner } from '../../actions/editor.actions';
import { validateSearchNameOnSaveAs } from '../../utils/validation.utils';

const useStyles = makeStyles({
  modal: {
    width: 650,
  },
  confirmModal: {
    '& [class*="MuiDialogContent-root"]': {
      paddingBottom: 5,
    },
  },
});

const SaveAsModal = ({
  isOpen,
  initialSavedSearchName = '',
  entityName,
  handleClose,
  setIsLoading,
  redirectToSavedSearch,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [savedSearchName, setSavedSearchName] = useState(initialSavedSearchName);
  const [error, setError] = useState({ hasError: false, errorText: '' });
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const saveSavedSearch = async () => {
    if (isConfirmModalOpen) {
      setIsConfirmModalOpen(false);
    }

    await dispatch(
      saveSavedSearchDesigner({
        isSaveAs: true,
        newSavedSearchName: savedSearchName,
        setIsLoading,
        redirectToSavedSearch,
      })
    );
    handleClose();
  };

  const handleSaveProgressButton = async () => {
    const { exists } = await getSavedSearchExists({
      name: savedSearchName,
      entityName,
    });

    if (exists) {
      setIsConfirmModalOpen(true);
    } else {
      saveSavedSearch();
    }
  };

  const handleSavedSearchNameFieldBlur = () => {
    const errorObj = validateSearchNameOnSaveAs(savedSearchName);
    setError(errorObj);
  };

  return (
    <>
      <Modal
        open={isOpen}
        variant="default"
        onClose={handleClose}
        title={translateString('Save As Saved Search')}
        buttonProps={[
          {
            label: translateString('Cancel'),
          },
          {
            label: translateString('Save'),
            onClick: handleSaveProgressButton,
            disabled: error.hasError,
          },
        ]}
        className={classes.modal}
        disableBackdropClick
      >
        <TextField
          label={translateString('Saved Search Name')}
          placeholder={translateString('Saved Search Name...')}
          name="savedSearchName"
          value={savedSearchName}
          onChange={(e) => setSavedSearchName(e.target.value)}
          onBlur={handleSavedSearchNameFieldBlur}
          error={error.hasError}
          helperText={error.hasError ? translateString(error.errorText) : null}
          InputProps={{
            inputProps: {
              maxLength: 120,
            },
          }}
          fullWidth
          required
        />
      </Modal>

      {isConfirmModalOpen && (
        <Modal
          open={isConfirmModalOpen}
          className={classes.confirmModal}
          variant="warning"
          onClose={() => setIsConfirmModalOpen(false)}
          title={translateString('Confirm Save')}
          buttonProps={[
            {
              label: translateString('Cancel'),
            },
            {
              label: translateString('Save'),
              onClick: saveSavedSearch,
            },
          ]}
          disableBackdropClick
        >
          <p>
            <b>{savedSearchName} </b>
            {translateString('Saved Search already exists. Do you want to overwrite it?')}
          </p>
        </Modal>
      )}
    </>
  );
};

export default SaveAsModal;
